<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" loader="dots"></loading>
    <div class="layout-list">
      <div>
        <el-button size="small" type="primary" @click="saveLobbyTV"
          >儲存</el-button
        >
      </div>
    </div>
    <el-form>
      <div v-if="LobbyData">
        <span>設定</span>
        <draggable
          class="frame-list"
          :list="LobbyData.Frames"
          ghost-class="ghost"
          :group="{ name: 'myGroup', pull: 'clone', put: false }"
          itemKey="id"
          :options="{ animation: 500 }"
          :sort="false"
        >
          <div
            v-for="(Frame, index) in LobbyData.Frames"
            :key="Frame.Guid"
            class="frame-wrap"
          >
            <span class="frame-name">{{ Frame.Name }}</span>

            <div class="video-wrap" v-if="Frame.Type !== 1">
              <el-switch
                style="display: inline-block"
                v-model="Frame.Type"
                active-color="#66b1ff"
                inactive-color="#66b1ff"
                active-text="上傳圖片"
                inactive-text="上傳影片"
                :active-value="4"
                :inactive-value="3"
                @change="clearFrameValue(index)"
              >
              </el-switch>
              <br /><br />

              <el-form-item>
                <img
                  v-if="Frame.Type === 4 && Frame.ImgInfo"
                  style="width: 100%"
                  :src="Frame.ImgInfo.HeadPhotoBase64"
                  alt=""
                />
                <span v-if="Frame.Type === 3 && Frame.FileInfo">{{
                  Frame.FileInfo.FileName
                }}</span>
                <el-upload
                  class="upload-demo"
                  action
                  :accept="Frame.Type === 4 ? 'image/*' : 'video/mp4'"
                  :ref="`Frame${index}`"
                  :limit="1"
                  :on-change="
                    (file, fileList) => {
                      uploadFile(file, fileList, index);
                    }
                  "
                  :auto-upload="false"
                  :show-file-list="false"
                >
                  <el-button size="small" type="primary">上傳</el-button>
                </el-upload>
              </el-form-item>
            </div>
          </div>
        </draggable>
      </div>

      <div>
        <span>排版</span>
      </div>
      <!-- MaxSeq 最大數量 -->
      <div
        class="format-block"
        style="display: flex"
        v-if="LobbyData && LobbyData.Formats"
      >
        <div
          style="margin-right: 30px"
          v-for="format in LobbyData.Formats"
          :key="format.FormatId"
        >
          <el-radio
            @input="changeFormat"
            v-model="currentFormat"
            :label="format.FormatId"
            >{{ format.FormatName }}</el-radio
          >

          <div class="format-list">
            <draggable
              v-for="dragWrap in format.Sorts"
              :key="dragWrap.Seq"
              class="drag-wrap"
              :list="dragWrap.Frames"
              :group="{ name: 'my-group', pull: true, put: true }"
              @change="onChange($event, format.FormatId, dragWrap.Seq)"
            >
              <div
                class="frame-wrap"
                v-for="(item, index) in dragWrap.Frames"
                :key="index"
              >
                {{ item.Name }}

                <eva-icon
                  @click="removeFrame(item.Guid, format.FormatId, dragWrap.Seq)"
                  class="remove-btn"
                  name="close-circle"
                  fill="#FFF"
                  width="30"
                  height="30"
                ></eva-icon>
              </div>
            </draggable>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "RoomScheduleSetting",

  data() {
    return {
      currentFormat: null,
      LobbyData: null,
      uploadFileList: [],
      fileGroupGuid: "",
      currentFrameIndex: null,
    };
  },
  methods: {
    cloneAction(item) {
      console.log("cloned", item);
    },

    onChange(evt, FormatId, Seq) {
      const vm = this;
      // eslint-disable-next-line no-prototype-builtins
      if (evt.hasOwnProperty("added")) {
        let element = evt.added.element;

        let params = {
          FrameGuid: element.Guid,
          FormatId: FormatId,
          Seq: Seq,
          OldSeq: element.CurrentSeq,
          OldFormat: element.CurrentFormat,
        };
        vm.$api.InterviewSch.moveLobbyTV(params).then((response) => {
          if (response.data.ErrorMessage) {
            vm.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.getLobbyTV();
            vm.$notify({
              message: response.data.Data,
              type: "success",
            });
          }
          vm.$store.dispatch("updateLoading", false);
        });
      }
    },

    onAdd(e, FormatId, Seq) {
      const vm = this;
      let currentFrame = JSON.parse(JSON.stringify(e.item._underlying_vm_));

      let params = {
        FrameGuid: currentFrame.Guid,
        FormatId: FormatId,
        Seq: Seq,
      };
      vm.$api.InterviewSch.moveLobbyTV(params).then((response) => {
        if (response.data.ErrorMessage) {
          vm.$notify({
            message: response.data.ErrorMessage,
            type: "error",
          });
        } else {
          vm.getLobbyTV();
          vm.$notify({
            message: response.data.Data,
            type: "success",
          });
        }
        vm.$store.dispatch("updateLoading", false);
      });
    },

    clearFrameValue(index) {
      const vm = this;
      vm.LobbyData.Frames[index].Value = null;
      vm.LobbyData.Frames[index].FileInfo = null;
      vm.LobbyData.Frames[index].ImgInfo = null;
    },

    removeFrame(Guid, FormatId, OldSeq) {
      const vm = this;

      let params = {
        FrameGuid: Guid,
        FormatId: FormatId,
        Seq: null,
        OldSeq: OldSeq,
        OldFormat: FormatId,
      };
      vm.$api.InterviewSch.moveLobbyTV(params).then((response) => {
        if (response.data.ErrorMessage) {
          vm.$notify({
            message: response.data.ErrorMessage,
            type: "error",
          });
        } else {
          vm.getLobbyTV();
          vm.$notify({
            message: response.data.Data,
            type: "success",
          });
        }
        vm.$store.dispatch("updateLoading", false);
      });
    },

    // 上傳 檔案
    uploadFile(file, fileList, index) {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      let tempText = "Frame" + index;

      let uploadFilesArrLength = vm.$refs[tempText][0].uploadFiles.length; //上传文件列表

      if (uploadFilesArrLength === 0) {
        console.log("第一次上傳");
      } else {
        //el-upload第二次上傳會失效修正
        vm.$refs[tempText][0].uploadFiles = [];
      }

      let fd = new FormData();
      fd.append("File", file.raw);
      fd.append("FileType", file.raw.type);
      fd.append("FileGroupGuid", this.fileGroupGuid);
      fd.append("CreateUser", null);

      this.$api.file
        .uploadFile(fd)
        .then((response) => {
          if (response.status === 200) {
            vm.$store.dispatch("updateLoading", false);
            vm.$set(vm.LobbyData.Frames[index], "Value", response.data);

            if (vm.LobbyData.Frames[index].Type === 3) {
              this.getFileDetails(response.data, index);
            } else {
              this.getImgDetail(response.data, index);
            }
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "錯誤",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    getLobbyTV() {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      vm.$api.InterviewSch.getLobbyTV().then((response) => {
        if (response.data.ErrorMessage) {
          this.$notify({
            message: response.data.ErrorMessage,
            type: "error",
          });
        } else {
          vm.LobbyData = response.data.Data;
          vm.LobbyData.Frames = vm.LobbyData.Frames.map((item) => {
            return {
              ...item,
              FileInfo: null,
              ImgInfo: null,
            };
          });
          let currentSelectedItem = response.data.Data.Formats.find((item) => {
            return item.Selected;
          });

          vm.currentFormat = currentSelectedItem.FormatId;
          vm.LobbyData.Frames.forEach((element, index) => {
            if (element.Type === 3) {
              vm.getFileDetails(element.Value, index);
            } else if (element.Type === 4) {
              vm.getImgDetail(element.Value, index);
            }
          });
        }
        vm.$store.dispatch("updateLoading", false);
      });
    },

    saveLobbyTV() {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      vm.$api.InterviewSch.saveLobbyTV(vm.LobbyData.Frames).then((response) => {
        if (response.data.ErrorMessage) {
          this.$notify({
            message: response.data.ErrorMessage,
            type: "error",
          });
        } else {
          vm.getLobbyTV();
          vm.$notify({
            message: response.data.Data,
            type: "success",
          });
        }
        vm.$store.dispatch("updateLoading", false);
      });
    },

    // 取得 附件
    getFileDetails(Guid, index) {
      const vm = this;
      const params = {
        resetFileStatus: null,
      };
      this.$api.file
        .getFileDetails({ ...params }, Guid)
        .then((response) => {
          if (response.status === 200) {
            this.$store.dispatch("updateLoading", false);
            vm.$set(vm.LobbyData.Frames[index], "FileInfo", response.data[0]);
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "影片取得失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 取得大頭照 API
    getImgDetail(Guid, index) {
      const vm = this;
      const api = `${window.endpoints.api}/FileUpload/GetResumeHeadPhoto`;

      const params = {
        photoFileGroupId: Guid,
        resetFileStatus: null,
      };

      vm.$http
        .get(api, { params })
        .then((response) => {
          let imgInfo = {
            FileGuid: response.data.FileGuid,
            HeadPhotoBase64: response.data.HeadPhotoBase64,
          };

          vm.$set(vm.LobbyData.Frames[index], "ImgInfo", imgInfo);
          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "圖片取得失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    changeFormat(val) {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      vm.$api.InterviewSch.changeLobbyTVFormat(val).then((response) => {
        if (response.data.ErrorMessage) {
          this.$notify({
            message: response.data.ErrorMessage,
            type: "error",
          });
        } else {
          vm.$notify({
            message: response.data.Data,
            type: "success",
          });
        }
        vm.$store.dispatch("updateLoading", false);
      });
    },
  },
  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  created() {
    this.getLobbyTV();
  },
};
</script>

<style lang="scss" scoped>
.layout-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  label {
    cursor: pointer;
  }
  input {
    display: none;
    &:checked + img {
      outline: 2px solid #000;
    }
  }
  img {
    width: 45px;
    margin-right: 10px;
  }
}
.block-wrap {
  background-color: #fff;
  border: 1px solid rgb(223, 223, 223);
  padding: 20px;
  border-radius: 10px;
  height: 100%;
  max-height: 200px;
  margin-bottom: 20px;
}
.col-md-6 {
  margin-bottom: 20px;
}

.frame-list {
  display: flex;
  .frame-wrap {
    flex: 1;
    margin-right: 10px;
    border: 3px solid #373737;
    position: relative;
    padding: 5px;
    border-radius: 5px;
    background-color: #fff;

    &:last-child {
      margin-right: 0;
    }
    .frame-name {
      background-color: #373737;
      color: #fff;
      display: block;
      text-align: center;
      line-height: 30px;
      border-radius: 5px;
    }
    .video-wrap {
      padding: 10px 20px;
    }
  }
}

.format-list {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  height: 200px;

  .drag-wrap {
    height: calc(50% - 10px);

    overflow: hidden;
    width: 300px;
    border: dashed 1px #000;
    margin: 5px;
    background-color: #fff;
    padding: 10px;
    .frame-wrap {
      background-color: #373737;
      color: #fff;
      padding: 0 10px;
      height: 100%;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .remove-btn {
      cursor: pointer;
    }
  }
}

.sortable-ghost {
  opacity: 0.2;
  .video-wrap {
    display: none;
  }
}
</style>
